export const SET_PATIENT_ALLERGIES = 'Set patient allergies'
export const DELETE_PATIENT_ALLERGIES = 'Delete patient allergies'
export const UPDATE_PATIENT_ALLERGIES = 'Update patient allergies'
